import CoreuiController from "../lib/coreui-controller"
import RangeSlider from "../coreui/range-slider"

export default class CoreuiRangeSliderController extends CoreuiController {
  static Component = RangeSlider
}
